import { Transaction } from '../Transaction';
import { Month } from '../../util/date';

const getTransactionMonth = (transaction: Transaction): Month => {
	return { year: transaction.date.getYear(), month: transaction.date.getMonth() };
};

export default getTransactionMonth;
